import { useEffect } from 'react';
import { Paper, Tab, Tabs, alpha, useTheme } from '@mui/material';

export const WORKER_DETAIL_TAB = {
    OVERVIEW: 0,
    QUESTIONS: 1,
    DOCUMENTS: 2,
    EXPERIENCE: 3,
    EASYFLEX: 4,
    EASYFLEX_DOCS: 5,
    CHANNELS: 6,
    CERT_REVIEW: 7,
    CONTACT: 8,
    FEEDBACK: 9,
    HISTORY: 10,
} as const;

const TABS = [
    { value: WORKER_DETAIL_TAB.OVERVIEW, label: 'Overview' },
    { value: WORKER_DETAIL_TAB.QUESTIONS, label: 'Questions' },
    { value: WORKER_DETAIL_TAB.DOCUMENTS, label: 'Documents' },
    { value: WORKER_DETAIL_TAB.EXPERIENCE, label: 'Experience' },
    { value: WORKER_DETAIL_TAB.EASYFLEX, label: 'EasyFlex' },
    { value: WORKER_DETAIL_TAB.EASYFLEX_DOCS, label: 'EasyFlex Docs' },
    { value: WORKER_DETAIL_TAB.CHANNELS, label: 'Channels' },
    { value: WORKER_DETAIL_TAB.CERT_REVIEW, label: 'Certificate Review' },
    { value: WORKER_DETAIL_TAB.CONTACT, label: 'Contact', manageOnly: true },
    { value: WORKER_DETAIL_TAB.FEEDBACK, label: 'Feedback', manageOnly: true },
    { value: WORKER_DETAIL_TAB.HISTORY, label: 'History' },
];

export function WorkerDetailTabs({
    value,
    onChange,
    disabled,
    mobile,
    canManageWorkers,
}: {
    value: number;
    onChange: (value: number) => void;
    disabled: boolean;
    mobile: boolean;
    canManageWorkers: boolean;
}) {
    const theme = useTheme();
    const visibleTabs = TABS.filter((tab) => !tab.manageOnly || canManageWorkers);
    const valueIsVisible = visibleTabs.some((tab) => tab.value === value);
    const effectiveValue = valueIsVisible ? value : WORKER_DETAIL_TAB.OVERVIEW;

    useEffect(() => {
        if (!valueIsVisible) onChange(WORKER_DETAIL_TAB.OVERVIEW);
    }, [onChange, valueIsVisible]);

    return (
        <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden', borderColor: alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.4 : 1) }}>
            <Tabs value={effectiveValue} onChange={(_, next) => onChange(next)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile={mobile} sx={{ '& .MuiTabs-indicator': { height: 3 }, '& .MuiTab-root': { textTransform: 'none', fontWeight: 800 } }}>
                {visibleTabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        disabled={disabled && tab.value !== WORKER_DETAIL_TAB.OVERVIEW}
                    />
                ))}
            </Tabs>
        </Paper>
    );
}
